import { AddAmbientConditions } from "components/AddAmbientConditions/AddAmbientConditions"
import { CriteriaCatalogCard } from "components/CriteriaCatalogCard/CriteriaCatalogCard"
import { ParameterCard } from "components/ParameterCard/ParameterCard"
import { TakeFotoBox } from "components/TakeFotoBox/TakeFotoBox"
import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"
import { WitnessSelection } from "components/Witnesses/WitnessSelection"
import { Examination, File, TestData } from "graphql/types"

type TestSetupProps = {
  data: TestData
  // eslint-disable-next-line no-unused-vars
  setData: (arg: TestData) => void
  examination: Examination | undefined
  // eslint-disable-next-line no-unused-vars
  setExamination: React.Dispatch<React.SetStateAction<Examination | undefined>>
}

export const TestConfiguration = (props: TestSetupProps) => {
  const { data, setData, examination, setExamination } = props

  const setImageData = (images: File[]) => {
    setData({
      ...data,
      image: images,
    })
  }

  return (
    <>
      {examination && <ParameterCard examination={examination} setExamination={setExamination} />}
      {examination && (
        <CriteriaCatalogCard examination={examination} setExamination={setExamination} />
      )}
      <AddAmbientConditions data={data} setData={setData} />
      <WitnessSelection data={data} setData={setData} />
      <TakeNoteBox data={data} setData={setData} name="Testvorbereitung" setName={false} />
      <TakeFotoBox setImages={setImageData} images={data.image} imageName={"Testvorbereitung"} />
    </>
  )
}
